export default "assets/images/texture_card-005e017d.png";